import { store } from '../store/storeMain'
import { transactionManager } from './transactionManager'

export const expenseManager = {

  expenses: [],

  expenseObject: {
    id: 0,
    expenseName: '',
    account: '',
    budget: 'None',
    expenseType: '',
    amount: 0,
    expenseAmount: 0,
    currencyConversion: {},
    currency: '',
    expenseDate: '',
    expenseTime: '',
    comment: '',
    category: '',

    //Recurring
    repeat: 1,
    cycle: '',
    period: 'Forever',
    numberOfCycles: 1,
    goesOffFirst: '',

    //State of Current Object
    objectState: 'New',
    show: false
  },

  getExpense() {
    this.expenses = store.state.Expenses
  },

  addExpense(expense) {
    let newEntry = JSON.parse(JSON.stringify(expense))

    this.addDialog = false

    newEntry.id = this.getLargestIdFromItems() + 1

    this.addExpenseToStore(newEntry)
  },

  getLargestIdFromItems() {
    this.getExpense()

    let largest = 0
    for (let i = 0; i < this.expenses.length; i++) {
      if (this.expenses[i].id > largest) {
        largest = this.expenses[i].id
      }
    }
    return largest
  },

  addExpenseToStore(newEntry) {
    store.commit('addNewExpenseToStore', newEntry)
  },

  createTransactionFromExpense(expense) {
    let transaction = this.convertExpenseToTransaction(expense)

    transactionManager.addTransaction(transaction)
  },

  convertExpenseToTransaction(expense) {
    let transaction = transactionManager.transactionObject

    //Replace Data from Expense
    transaction.account = expense.account
    transaction.budget = expense.budget
    transaction.transactionName = expense.expenseName
    transaction.transactionType = 'expense'
    transaction.transactionAmount = expense.expenseAmount
    transaction.comment = expense.comment
    transaction.category = expense.category
    transaction.currency = expense.currency
    transaction.transactionDate = expense.expenseDate
    transaction.transactionTime = expense.expenseTime

    if (expense.expenseType === "Recurring") {
      transaction.recurringTransaction = true
    }
    else if (expense.expenseType === "OneTime") {
      transaction.recurringTransaction = false
    }

    transaction.repeat = expense.repeat
    transaction.cycle = expense.cycle
    transaction.period = expense.period
    transaction.numberOfCycles = expense.numberOfCycles
    transaction.goesOffFirst = expense.goesOffFirst
    transaction.objectState = expense.objectState


    return transaction
  },

  updateTransactionFromExpense(expense) {
    let oldTransaction = transactionManager.getTransactionByName(expense.expenseName)

    let newTransaction = this.convertExpenseToTransaction(expense)

    transactionManager.updateTransaction(oldTransaction, newTransaction)
  },

  rollbackTransactionFromExpense(expense) {
    expense.objectState = 'Delete'

    transactionManager.updateTransactionFromExpense(expense)
  },

  createExpenseFromTransaction(transaction) {
    let newExpense = this.convertTransactionToExpense(transaction)

    this.addExpense(newExpense)
  },

  convertTransactionToExpense(transaction) {
    let expense = this.expenseObject

    expense.account = transaction.account
    expense.budget = transaction.budget
    expense.expenseName = transaction.transactionName
    //transaction.transactionType = 'expense'
    expense.expenseAmount = transaction.transactionAmount
    expense.comment = transaction.comment
    expense.category = transaction.category
    expense.currency = transaction.currency
    expense.expenseDate = transaction.transactionDate
    expense.expenseTime = transaction.transactionTime

    if (transaction.recurringTransaction) {
      expense.expenseType === "Recurring"
    }
    else if (!transaction.recurringTransaction) {
      expense.expenseType === "OneTime"
    }

    expense.repeat = transaction.repeat
    expense.cycle = transaction.cycle
    expense.period = transaction.period
    expense.numberOfCycles = transaction.numberOfCycles
    expense.goesOffFirst = transaction.goesOffFirst
    expense.objectState = transaction.objectState


    return expense
  }

}



// WEBPACK FOOTER //
// ./src/javascript/expenseManager.js